import React from 'react';
import './icon.css';
import { getIconFromName } from '../../helpers/icon';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Icon = props => {
    const {
        iconName,
        colorScheme,
        size,
        isDisabled,
        isLocked,
        type,
        altText,
        pressIcon,
    } = props;

    const name =
        iconName === 'next' ||
        iconName === 'previous' ||
        iconName === 'back' ||
        iconName === 'enter' ||
        iconName === 'submit'
            ? 'arrow'
            : iconName;

    const icon = getIconFromName(name);

    const iconClasses = classNames({
        icon: true,
        'icon--disabled': isDisabled,
        'icon--locked': isLocked,
        'icon--dark': colorScheme === 'dark',
        'icon--rotate-180': iconName === 'back' || iconName === 'previous',
        'icon--green': colorScheme === 'green',
        'icon--edit': iconName === 'edit',
        'icon--press': pressIcon === true,
        'icon--clock': iconName === 'clock',

        'icon--x-small': size === 'x-small',
        'icon--small': size === 'small' || isLocked,
        'icon--medium': size === 'medium',
        'icon--x-large': size === 'x-large',
    });

    return (
        <>
            {type === 'svg' ? (
                <div
                    className={iconClasses}
                    role="img"
                    aria-label={altText ?? iconName}
                >
                    {icon}
                </div>
            ) : (
                <img
                    src={icon}
                    alt={altText ?? iconName}
                    className={iconClasses}
                />
            )}
        </>
    );
};

Icon.defaultProps = {
    type: 'svg',
    colorScheme: 'light',
    size: 'large',
    isDisabled: false,
};

Icon.propTypes = {
    iconName: PropTypes.string,
    type: PropTypes.oneOf(['svg', 'png']),
    colorScheme: PropTypes.oneOf(['light', 'dark', 'green']),
    size: PropTypes.oneOf(['x-small', 'small', 'medium', 'large', 'x-large']),
    isDisabled: PropTypes.bool,
    altText: PropTypes.string,
};

export { Icon };
